module.exports = __webpack_public_path__ + "static/media/logo.c4c2db9f.png";